import { IsBoolean, IsEnum, IsString } from "class-validator";
import { Expose } from "class-transformer";
import { FORM_OF_PAYMENT_TYPE } from "@/static/formOfPaymentType";

export class OfficeFormOfPaymentByType {
  @IsEnum(FORM_OF_PAYMENT_TYPE)
  @Expose()
  id!: FORM_OF_PAYMENT_TYPE;
  @IsString()
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  isSelected!: boolean;
}
